import ApiError from 'util/api/errors/ApiError';

const ERROR_DETAIL_NOT_FOUND = 'INVALID_PAYLOAD';
const ERROR_MESSAGE_NOT_FOUND = 'Sorry, the submitted data was not valid.';

export default class BadRequestError extends ApiError {
    constructor(response) {
        super(ERROR_MESSAGE_NOT_FOUND, response, ERROR_DETAIL_NOT_FOUND);
    }
}



// WEBPACK FOOTER //
// ./src/util/api/errors/BadRequestError.js